import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Card } from '@/components/ui'
import { PedagogySectionNav } from '@/components/pedagogy/PedagogySectionNav'
import { PedagogyAccessErrorCard } from '@/components/pedagogy/PedagogyAccessStates'
import { usePedagogyAccess } from '@/hooks/usePedagogyAccess'
import { isPedagogyChromelessPath } from '@/lib/pedagogyRoutes'

/**
 * Корень педагогического раздела: один гейт, одна навигация, один резолв доступа.
 *
 * До 21.08.2026 корня не было вовсе — гейт был скопирован в каждый из десяти
 * `element={}`, поэтому размонтировался на каждом переходе и заново дёргал
 * `pedagogy_teacher_registry_access_role()` (на карточке специалиста — трижды),
 * давая вспышку «Проверяем доступ…» на каждый клик по вкладке. Навигация
 * вклеивалась в страницы вручную и на «Вместимости студий» просто отсутствовала.
 */
export function PedagogySectionLayout() {
  const location = useLocation()
  const { loading, canViewPedagogySection, accessError, retryAccessCheck } = usePedagogyAccess()

  if (loading) {
    return (
      <div className="space-y-4 pb-24">
        <Card>
          <div className="py-10 text-center text-sm text-muted-foreground">
            Проверяем доступ…
          </div>
        </Card>
      </div>
    )
  }

  /*
    Сбой проверки — не отказ в правах. Редирект здесь означал бы, что обрыв
    сети неотличим от отзыва доступа: человек уезжает на /management/hub без
    единого слова и идёт спрашивать администратора вместо кнопки «Повторить».
  */
  if (accessError) {
    return <PedagogyAccessErrorCard onRetry={retryAccessCheck} />
  }

  if (!canViewPedagogySection) {
    return <Navigate to="/management/hub" replace />
  }

  // Печатная форма отчёта — полностраничный белый лист под PDF, вкладки в нём лишние.
  if (isPedagogyChromelessPath(location.pathname)) {
    return <Outlet />
  }

  return (
    <div className="space-y-4">
      <PedagogySectionNav />
      <Outlet />
    </div>
  )
}
